import { WarningOutlined } from '@ant-design/icons';
import { Popover, Space } from 'antd';
import React, { ReactElement, ReactNode } from 'react';

export default function PopoverWarning(props: {
    help?: React.ReactNode;
    validateStatus: 'error' | '';
    children: ReactNode;
}): ReactElement {
    const { validateStatus, help, children } = props;

    const warningBlock: ReactElement = validateStatus === 'error' && <WarningOutlined/>;

    return (
        <Popover className='popover-warning' content={validateStatus && help}>
            <Space className={validateStatus === 'error' && 'error'}>
                {children}
                {warningBlock}
            </Space>
        </Popover>
    );
}